import { Helmet } from "react-helmet-async";
import { COMPANY } from "../data/site";

/**
 * SEO — wraps Helmet to set title, meta description, canonical and OG tags.
 * Canonical uses the primary brand domain (trädfällarna.nu).
 */
export default function SEO({
  title,
  description,
  path = "/",
  image,
  type = "website",
  noindex = false,
  children,
}) {
  const canonical = `${COMPANY.primaryDomain}${path}`;
  const ogImage = image || `${COMPANY.primaryDomain}/images/hero.webp`;

  // Build-time prerendering only needs the page body. Cloudflare's edge
  // middleware owns the initial <head> metadata for static public routes.
  // Returning null on the server prevents React 19 from emitting Helmet's
  // title/meta/link nodes inside #root. In the browser Helmet still manages
  // head metadata normally after hydration/navigation.
  if (typeof window === "undefined") {
    return null;
  }

  return (
    <Helmet>
      <html lang="sv" />
      <title>{title}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex,nofollow" />}

      <meta property="og:type" content={type} />
      <meta property="og:title" content={title} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content={COMPANY.name} />
      <meta property="og:locale" content="sv_SE" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={ogImage} />

      {children}
    </Helmet>
  );
}
